import script from "./contnet-item.vue?vue&type=script&setup=true&lang=js"
export * from "./contnet-item.vue?vue&type=script&setup=true&lang=js"

import "./contnet-item.vue?vue&type=style&index=0&id=649a49e4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649a49e4"]])

export default __exports__